import * as React from 'react'
import Grid from '@mui/material/Grid';
import { Button, FormControl, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { UserResp, UserTenantInfo } from '../../api';
import * as yup from "yup"
import UnstyledLink from '../../components/common/UnstyledLink/UnstyledLink';
import { usersApi } from '../../api-interface';
import { useContext } from 'react';
import { TenantContext } from '../..';
import { useSnackbar } from 'notistack';


const UserEdit = () => {

    const { user_id } = useParams();
    const { users } = useLoaderData() as { users: UserResp, pending: any };
    const { enqueueSnackbar } = useSnackbar();
    const user = users.users.find((x) => x.user_id == user_id)
    if (!user){
        throw new Error('User not found'); 
    }
    const currentTenant = useContext(TenantContext)
    const navigate = useNavigate()

    const schema = yup
        .object({
            first_name: yup.string().required("First Name is required").min(2, "First name must be at least two characters"),
            last_name: yup.string().required().min(2),
            email: yup.string().required().email(),
            user_management: yup.bool(),
            receive_reminders: yup.bool(),
            user_enabled: yup.bool()
        })
        .required()

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const handleUpdateUser = async (form) => {
        try{
            await usersApi(currentTenant).updateUserUsersUserIdPatch(
                user_id!, 
                {
                    user_id:user_id, 
                    tenant_id:currentTenant, 
                    user_disabled:!form.user_enabled, 
                    ...form
                }
            )
            enqueueSnackbar("User updated", {variant:"success"})
            navigate("/dashboard/"+currentTenant+"/users")
        } catch(e){
            if (e?.response?.data?.detail){
                enqueueSnackbar(e.response.data.detail, {variant:"error"})
            } else{
                enqueueSnackbar("Error: " + e, {variant:"error"})
            }
        }

    }


    return (
        <Grid size={{xs:11}}>
            <Grid rowSpacing={2} container>
                <Grid size={{xs:12}}>
                    <Typography variant="h4" > Edit User </Typography>
                </Grid>
                <Grid size={{xs:12, sm: 12, md: 12, lg:8, xl:4}}>
                    <form onSubmit={handleSubmit(handleUpdateUser)}>
                        <FormControl fullWidth>
                            <Typography marginTop={3} variant='subtitle1'>User Details</Typography>
                            <TextField
                                margin="normal"
                                label="First Name"
                                placeholder="First Name"
                                {...register('first_name')}
                                error={errors.first_name ? true : false}
                                helperText={errors.first_name?.message?.toString()}
                                defaultValue={user?.first_name}
                                type="text"
                                variant='outlined'
                                required
                            />
                            <TextField
                                margin="normal"
                                label="Last Name"
                                placeholder="Last Name"
                                {...register('last_name')}
                                error={errors.last_name ? true : false}
                                helperText={errors.last_name?.message?.toString()}
                                defaultValue={user?.last_name}
                                type="text"
                                variant='outlined'
                                required
                            />
                            <TextField
                                margin="normal"
                                label="Email Address"
                                placeholder="Email Address"
                                {...register('email')}
                                error={errors.email ? true : false}
                                helperText={errors.email?.message?.toString()}
                                defaultValue={user?.email}
                                type="text"
                                variant='outlined'
                                required
                            />
                        </FormControl>
                        <FormControl>
                            <Typography marginTop={3} variant='subtitle1'>User Permissions</Typography>
                            <FormControlLabel
                                control={
                                    <Switch
                                        defaultChecked={user?.user_management} 
                                        {...register('user_management')}
                                     />
                                }
                                label="User Management" />
                            <FormControlLabel
                                control={
                                    <Switch
                                        defaultChecked={user?.receive_reminders} 
                                        {...register('receive_reminders')}
                                     />
                                }
                                label="User Receives Reminder Emails" />
                            <Typography marginTop={3} variant='subtitle1'>User Status</Typography>
                            <FormControlLabel

                                control={
                                    <Switch
                                        defaultChecked={!user?.user_disabled} 
                                        {...register('user_enabled')}
                                     />
                                }
                                label={watch("user_enabled", !user?.user_disabled)?"User Enabled":"User Disabled"} />
                            <Stack marginTop={5} spacing={2} direction="row">
                                <UnstyledLink to=".." relative="path"><Button variant="outlined" >Cancel</Button></UnstyledLink>
                                <Button variant="contained" type="submit">Save</Button>
                            </Stack>
                        </FormControl>
                    </form>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default UserEdit